import './index.scss';
import { useState, useEffect } from 'react'
import { get } from '../../../util/request';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default LandAndLoanInvestments; function LandAndLoanInvestments() {
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [landAndLoanInvestments, setLandAndLoanInvestments] = useState([]);
    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));

    const getLandAndLoanInvestments = async () => {
        const clientId = user.sfUserType === 'IR' ? previewDetail?.clientId : user.clientID;
        if (clientId !== undefined && clientId !== '' && clientId !== null) {
            let params = {
                accessToken: user.accessToken,
                userId: user.userId,
                clientId: user.sfUserType === 'IR' ? previewDetail?.clientId : user.clientID
            }

            const data = await get('home/landAndLoanInvestments', params);
            setLandAndLoanInvestments(data);
        }
    }

    const formatNumber = (value) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(value);

    useEffect(() => {
        getLandAndLoanInvestments();
    }, []);

    return (<>
        <div className='land-and-loan-investments'>
            <div className="land-investment row">
                <p className='left-border home-title'>
                    {t('Land Investment')}
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>{t('Region & Currency')}</th>
                            <th>{t('Total Original Investment')}</th>
                            <th>{t('Total Active Amount')}</th>
                            <th>{t('Total Gross Proceeds')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            landAndLoanInvestments != null ? (<>{
                                landAndLoanInvestments.filter(x => x.productType.toUpperCase() !== "LOAN" && x.currencyCode === 'USD').length > 0 ? (<>
                                    {
                                        landAndLoanInvestments.filter(x => x.productType.toUpperCase() !== "LOAN" && x.currencyCode === 'USD').map((land) => (<>
                                            <tr>
                                                <td>{land.assetRegion} ({land.currencyCode})</td>
                                                <td>{(land.totalOriginalInvestment === 0 || land.totalOriginalInvestment === null) ? '-' : formatNumber(land.totalOriginalInvestment)}</td>
                                                <td>{(land.totalActiveAmount === 0 || land.totalActiveAmount === null) ? '-' : formatNumber(land.totalActiveAmount)}</td>
                                                <td>{(land.totalNetExitAmount === 0 || land.totalNetExitAmount === null) ? '-' : formatNumber(land.totalNetExitAmount)}</td>
                                            </tr>
                                        </>))
                                    }
                                </>) : (<>
                                    <tr>
                                        <td>United States (USD)</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                    </tr>
                                </>)
                            }
                            </>) : null
                        }
                        {
                            landAndLoanInvestments != null ? (<>{
                                landAndLoanInvestments.filter(x => x.productType.toUpperCase() !== "LOAN" && x.currencyCode === 'CAD').length > 0 ? (<>
                                    {
                                        landAndLoanInvestments.filter(x => x.productType.toUpperCase() !== "LOAN" && x.currencyCode === 'CAD').map((land) => (<>
                                            <tr>
                                                <td>{land.assetRegion} ({land.currencyCode})</td>
                                                <td>{(land.totalOriginalInvestment === 0 || land.totalOriginalInvestment === null) ? '-' : formatNumber(land.totalOriginalInvestment)}</td>
                                                <td>{(land.totalActiveAmount === 0 || land.totalActiveAmount === null) ? '-' : formatNumber(land.totalActiveAmount)}</td>
                                                <td>{(land.totalNetExitAmount === 0 || land.totalNetExitAmount === null) ? '-' : formatNumber(land.totalNetExitAmount)}</td>
                                            </tr>
                                        </>))
                                    }
                                </>) : (<>
                                    <tr>
                                        <td>Canada (CAD)</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                    </tr>
                                </>)
                            }
                            </>) : null
                        }


                    </tbody>
                </table>
            </div>
            <div className="loan-investment row">
                <p className='left-border home-title'>
                    {t('Loan Investment')}
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>{t('Currency')}</th>
                            <th>{t('Total Original Principal')}</th>
                            <th>{t('Total Outstanding Balance')}</th>
                            <th>{t('Total Principal Repayment')}</th>
                            <th>{t('Total Interest Payment')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            landAndLoanInvestments != null ? (<>{
                                landAndLoanInvestments.filter(x => x.productType.toUpperCase() === "LOAN" && x.currencyCode === 'USD').length > 0 ? (<>
                                    {landAndLoanInvestments.filter(x => x.productType.toUpperCase() === "LOAN" && x.currencyCode === 'USD').map((loan) => (<>
                                        <tr>
                                            <td>{loan.assetRegion} ({loan.currencyCode})</td>
                                            <td>{(loan.totalOriginalPrincipal === 0 || loan.totalOriginalPrincipal === null) ? '-' : formatNumber(loan.totalOriginalPrincipal)}</td>
                                            <td>{(loan.totalOutstandingBalance === 0 || loan.totalOutstandingBalance === null) ? '-' : formatNumber(loan.totalOutstandingBalance)}</td>
                                            <td>{(loan.totalPrincipalRepayment === 0 || loan.totalPrincipalRepayment === null) ? '-' : formatNumber(loan.totalPrincipalRepayment)}</td>
                                            <td>{(loan.totalInterestPayment === 0 || loan.totalInterestPayment === null) ? '-' : formatNumber(loan.totalInterestPayment)}</td>
                                        </tr>
                                    </>))}
                                </>) : (<>
                                    <tr>
                                        <td>United States (USD)</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                    </tr>
                                </>)
                            }
                            </>) : null
                        }

                        {
                            landAndLoanInvestments != null ? (<>{
                                landAndLoanInvestments.filter(x => x.productType.toUpperCase() === "LOAN" && x.currencyCode === 'CAD').length > 0 ? (<>
                                    {
                                        landAndLoanInvestments.filter(x => x.productType.toUpperCase() === "LOAN" && x.currencyCode === 'CAD').map((loan) => (<>
                                            <tr>
                                                <td>{loan.assetRegion} ({loan.currencyCode})</td>
                                                <td>{(loan.totalOriginalPrincipal === 0 || loan.totalOriginalPrincipal === null) ? '-' : formatNumber(loan.totalOriginalPrincipal)}</td>
                                                <td>{(loan.totalOutstandingBalance === 0 || loan.totalOutstandingBalance === null) ? '-' : formatNumber(loan.totalOutstandingBalance)}</td>
                                                <td>{(loan.totalPrincipalRepayment === 0 || loan.totalPrincipalRepayment === null) ? '-' : formatNumber(loan.totalPrincipalRepayment)}</td>
                                                <td>{(loan.totalInterestPayment === 0 || loan.totalInterestPayment === null) ? '-' : formatNumber(loan.totalInterestPayment)}</td>
                                            </tr>
                                        </>))
                                    }
                                </>) : (<>
                                    <tr>
                                        <td>Canada (CAD)</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                    </tr>
                                </>)
                            }
                            </>) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </>);
}